import AdminNewSidebar from "components/admin/AdminNewSidebar";
import React, { useEffect, useRef, useState } from "react";
import { Box, Container } from "@mui/material";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Table,Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import apis from "../../services";

import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAdmin } from "redux/slices/adminSlice";

import useNavigate from "hooks/Navigate";
import { removeHTMLTags } from "utils/removeHTMLTags";
import { calculateWholeShareAllocation } from "utils/shareAllocation";
import LotAllocationPreview from "components/shareLots/LotAllocationPreview";
export default function AdminInvest() {

  const lang = localStorage.getItem("i18nextLng") || "sp";
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true)
  const [stores, setStores] = useState([]);
  const [lotQuote, setLotQuote] = useState(null);
  const idempotencyKeyRef = useRef(null);

  const [sharesData,setSharesData]=useState({
    "totalInvestor": 0,
    "totalStoreFundedAmount": 0,
    "TOTAL_SHARES": 120000000,
    "totalAvailableShares": 0,
    "TOTAL_PRICE_PER_SHARE": 29.79
  });
  const fetchData = async () => {
    setLoader(true);
    const res = await apis.getTotalRecord();
    setSharesData(res?.data);
    setLoader(false);
  };


  let {id} = useParams();


  const [data, setData] = useState({
    id:"",
    shareAmount:'',
    totalShares:''
  });

  const onChangeHandler = (e) => {
    idempotencyKeyRef.current = null;
    const { id, value } = e.currentTarget;
    const allocation = calculateWholeShareAllocation(
      value,
      sharesData?.TOTAL_PRICE_PER_SHARE
    );
    setData((prevState) => ({
      ...prevState,
      [id]: Number(value) / sharesData?.TOTAL_PRICE_PER_SHARE,
      investmentAmount: value,
      wholeShares: allocation.wholeShares,
      amountInvested: allocation.amountInvested,
      dividendRemainder: allocation.dividendRemainder,
    }));
  };

  const fetchAllStores = async () => {
    const res = await apis.getAllActiveStores();
    setStores(res?.data?.stores);
};

useEffect(() => {
  (async () => {
      await fetchAllStores();
      await fetchData();
  })();
}, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
if(data?.id)
{
  setLoader(true);
  if (!idempotencyKeyRef.current) {
    idempotencyKeyRef.current =
      window.crypto?.randomUUID?.() ||
      `admin-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  const response = await apis.adminInvestUser(id, {
    ...data,
    idempotencyKey: idempotencyKeyRef.current,
    wholeShares: lotQuote?.shareQuantity ?? data.wholeShares,
    amountInvested: lotQuote ? Number(lotQuote.amountInvestedMinor || 0) / 100 : data.amountInvested,
    dividendRemainder: lotQuote ? Number(lotQuote.dividendRemainderMinor || 0) / 100 : data.dividendRemainder,
  });
  if (response.status === 201) {
    idempotencyKeyRef.current = null;
    dispatch(setAdmin(response.data?.user))
      toast.success(response.data.message);
          setTimeout(() => navigate("/admin/users"), 2000);
  }

}
else{

  toast.error("Please select the store");
  
}  } catch (e) {
        console.error(e);
        toast.error(e.message)
        setLoader(false);
    }

}
  if (loader) {
    return (
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{ flexGrow: 1, height: "100vh", overflow: "auto" }}
            className="custom-scroll"
          >
            <Header />
            <div className="loader-container">
              <div className="loader" />
            </div>
          </Box>
        </div>
      </Box>
    );
  }
  
  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            <Container maxWidth="sm" sx={{ mt: 0, mb: 4 }}>
              <div className="bg-light p-5">
                <h3 className=""> User Investment </h3>
                <Form onSubmit={submitHandler}>
                  <Form.Group className="mb-3 pt-3" controlId="formGroupEmail">
                    <Form.Label>Investment Amount</Form.Label>
                    <Form.Control
                      type="number"
                      id="shareAmount"
                      min={30}
                      placeholder="Enter Investment Amount"
                      onChange={onChangeHandler}
                      required
                    />
                  </Form.Group>

                  <div className="border rounded p-3 mb-3 bg-white">
                    <div>Whole shares for user: <strong>{lotQuote?.shareQuantity ?? data.wholeShares ?? 0}</strong></div>
                    <div>Amount invested: <strong>${Number(lotQuote ? Number(lotQuote.amountInvestedMinor || 0) / 100 : data.amountInvested || 0).toFixed(2)} MXN</strong></div>
                    {Number(lotQuote ? Number(lotQuote.dividendRemainderMinor || 0) / 100 : data.dividendRemainder || 0) > 0 && (
                      <div>Added to user dividends: <strong>${Number(lotQuote ? Number(lotQuote.dividendRemainderMinor || 0) / 100 : data.dividendRemainder).toFixed(2)} MXN</strong></div>
                    )}
                  </div>

                  <LotAllocationPreview amount={data.investmentAmount} onQuote={setLotQuote} />

                  <Form.Label>Select Store</Form.Label>

                  <div style={{overflow: "auto", maxHeight: "150px"}}>

<Table bordered hover size="sm">
  <thead>
    <tr>
      <th>Image</th>
      <th>Name</th>
      <th>Shares</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {stores.length > 0 ? (
      stores.filter((item)=>item.active===true).map((item, i) => {
        return (
          <>
            <tr key={item.id} style={{ textAlign: 'center'}}>
              <td> <img src={item?.image} width={"41px"} height={"41px"} alt="image" /></td>
              <td>{removeHTMLTags(lang==="en"?item?.title_en:item?.title_sp)}</td>
           
              <td>{item?.totalShares}</td>
              <td><input  style={{ marginTop : '12px'}} type="checkbox" onClick={() => setData((prevState)=>({...prevState,id:item?._id , totalShares:item?.totalShares }))} checked={item?._id === data?.id} ></input></td>
            </tr>
          </>
        )
      })
    ) : (
      <tr style={{ textAlign: 'center' }} >
        <td colSpan={7}>No Stores</td>
      </tr>
    )}

  </tbody>
</Table>

</div>


                  <div className="m-3">
                 <Button className=' mx-auto' variant="outline-danger"
                                                type='submit'
                                                disabled={loader}> {loader ? t("buttons.submitting") : t("buttons.submit")}
                                        </Button>
                  </div>
                </Form>
              </div>
            </Container>
          </Box>
        </div>
      </Box>
    </>
  );
}
